import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { INTL_DMY_CASUAL_SHORT_FORMAT, INTL_LONG_WEEKDAY } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import { rem } from 'polished'
import styled from 'styled-components'

const Dates = styled.div`
  display: grid;
  grid-template-columns: ${rem(120)} min-content ${rem(120)};
  gap: ${rem(12)};
  align-items: center;
`

interface Props {
  departure: App.Tours.TourV2OfferDeparture
  gridArea?: string
}

function TourV2DepartureTileDates(props: Props) {
  const { departure, gridArea } = props

  const dateFormatter = useIntlDateFormatter()

  return <Dates style={{ gridArea }}>
    <div>
      <Heading variant="heading4" wrap="no-wrap">{dateFormatter(departure.startDate, INTL_DMY_CASUAL_SHORT_FORMAT)}</Heading>
      <BodyText variant="small" colour="neutral-three">{dateFormatter(departure.startDate, INTL_LONG_WEEKDAY)}</BodyText>
    </div>
    <LineArrowRightIcon size="M" />
    <div>
      <Heading variant="heading4" wrap="no-wrap">{dateFormatter(departure.endDate, INTL_DMY_CASUAL_SHORT_FORMAT)}</Heading>
      <BodyText variant="small" colour="neutral-three">{dateFormatter(departure.endDate, INTL_LONG_WEEKDAY)}</BodyText>
    </div>
  </Dates>
}

export default TourV2DepartureTileDates
